import { FieldValues, RegisterOptions } from 'react-hook-form';

import { NAME_MIN_LENGTH } from '../NewMeetingPopup.constants';

export function roomNameValidation<TFieldValues extends FieldValues = FieldValues>(
  minLengthMessage: string
): { validate: RegisterOptions<TFieldValues>['validate'] } {
  return {
    validate: (value: string): boolean | string => {
      const valueTrim = value.trim();

      if (!valueTrim || valueTrim.length < NAME_MIN_LENGTH) return minLengthMessage;

      return true;
    },
  };
}
